import React from "react";
import cn from "classnames";
import "./SideMenu.less";
import { useBreakpoint } from "../../../hooks";

type Props = {
    "aria-label"?: string;
    "aria-labelledby"?: string;
    /**
     * Used to set the background color for active elements.
     * Should match the background color of your application
     * @default 'white'
     */
    backgroundColor?: "white" | "grey100";
    className?: string;
    /**
     * If the item should collapse to only show icons
     * @default true
     */
    collapse?: boolean;
    children?: React.ReactNode;
};
export const SideMenu: React.FC<Props> = (props) => {
    const md = useBreakpoint("md");
    const collapse = props.collapse ?? true;

    return (
        <nav
            className={cn(
                "side-menu",
                { "side-menu--white": props.backgroundColor !== "grey100" },
                { "side-menu--collapsed": !md && collapse },
                props.className,
            )}
            aria-label={props["aria-label"]}
            aria-labelledby={props["aria-labelledby"]}
        >
            <ul className="side-menu__list">{props.children}</ul>
        </nav>
    );
};

export const SideMenuTop: React.FC<{ children?: React.ReactNode }> = (props) => (
    <li className="side-menu-top">
        <ul className="side-menu-top__list">{props.children}</ul>
    </li>
);

export const SideMenuBottom: React.FC<{ children?: React.ReactNode }> = (props) => (
    <li className="side-menu-bottom">
        <ul className="side-menu-bottom__list">{props.children}</ul>
    </li>
);
